import React from 'react';

import ProductShowView from '@components/shared/products/ProductShowView';
import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext';
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import { useLoaderData } from 'react-router-dom';

import { operatorApiFetch } from '@services/operator/apiService';
import { thirdPartyApiLogService } from '@services/operator/thirdPartyApiLogService';
import { webhookDeliveryService } from '@services/operator/webhookDeliveryService';
import { partnerApiLogService } from '@services/operator/partnerApiLogService';
import productLabelTemplateService from '@services/operator/productLabelTemplateService';

import operatorCable from '@/lib/operatorCable';

const ProductShow: React.FC = () => {
  const product = useLoaderData();
  const { addJob } = useOperatorNotification();
  const { operator } = useOperatorAuth();
  const productService = useOperatorProductService();

  return (
    <ProductShowView
      product={product}
      role="operator"
      productService={productService}
      labelTemplateService={productLabelTemplateService}
      thirdPartyApiLogService={thirdPartyApiLogService}
      webhookDeliveryService={webhookDeliveryService}
      partnerApiLogService={partnerApiLogService}
      addJob={addJob}
      cableManager={operatorCable}
      organizationId={operator?.organization_id}
    />
  );
};

export default ProductShow;
